import { lazy } from "react";
import IntroContent from "../../content/IntroContent.json";
import IntroBlueBlockContent from "../../content/IntroBlueBlockContent.json";
import MiddleBlockContent from "../../content/MiddleBlockContent.json";
import MiddleBlueBlockContent from "../../content/MiddleBlueBlockContent.json";
import BubbleBlockContent from "../../content/BubbleBlockContent.json";
import ServiceContent from "../../content/ServiceContent.json";
import PhotoContent from "../../content/PhotoContent.json";
import BusinessContent from "../../content/BusinessContent.json";
import JoinUsBlockContent from "../../content/JoinUsContent.json";
import ClosingBlockContent from "../../content/ClosingContent.json";
import WhyBlockContent from "../../content/WhyContent.json";

const MiddleBlock = lazy(() => import("../../components/MiddleBlock"));
const Container = lazy(() => import("../../common/Container"));
const ScrollToTop = lazy(() => import("../../common/ScrollToTop"));
const IntroBlock = lazy(() => import("../../components/IntroBlock"));
const IntroBlueBlock = lazy(() => import("../../components/IntroBlueBlock"));
const MiddleBlueBlock = lazy(() => import("../../components/MiddleBlueBlock"));
const BubbleBlock = lazy(() => import("../../components/BubbleBlock"));
const ServiceBlock = lazy(() => import("../../components/ServiceBlock"));
const PhotoBlock = lazy(() => import("../../components/PhotoBlock"));
const BusinessBlock = lazy(() => import("../../components/BusinessBlock"));
const JoinUsBlock = lazy(() => import("../../components/JoinUsBlock"));
const ClosingBlock = lazy(() => import("../../components/ClosingBlock"));
const WhyBlock = lazy(() => import("../../components/WhyBlock"));

const Home = () => {
  return (
    <Container>
      <ScrollToTop />
      <IntroBlock
        direction="up"
        title={IntroContent.title}
        content={IntroContent.text}
        button={IntroContent.button}
        icon="developer.svg"
        id="intro"
      />
      <IntroBlueBlock
        direction="up"
        number1={IntroBlueBlockContent.number1}
        number2={IntroBlueBlockContent.number2}
        number3={IntroBlueBlockContent.number3}
        text1={IntroBlueBlockContent.text1}
        text2={IntroBlueBlockContent.text2}
        text3={IntroBlueBlockContent.text3}
        id="introblue"
      />
      <MiddleBlock
        direction="up"
        question={MiddleBlockContent.question}
        title={MiddleBlockContent.title}
        text={MiddleBlockContent.text}
        text2={MiddleBlockContent.text2}
        button={MiddleBlockContent.button}
        id="middle"
      />
      <MiddleBlueBlock
        direction="up"
        text1={MiddleBlueBlockContent.text1}
        text2={MiddleBlueBlockContent.text2}
        text3={MiddleBlueBlockContent.text3}
        id="middleblue"
      />
      <BubbleBlock
        direction="up"
        text1={BubbleBlockContent.text1}
        text2={BubbleBlockContent.text2}
        text3={BubbleBlockContent.text3}
        id="bubble"
      />
      <ServiceBlock
        direction="up"
        text1={ServiceContent.text1}
        text2={ServiceContent.text2}
        text3={ServiceContent.text3}
        text4={ServiceContent.text4}
        id="service"
      />
      <PhotoBlock
        direction="up"
        text1={PhotoContent.text1}
        location={PhotoContent.location}
        sublocation={PhotoContent.sublocation}
        text2={PhotoContent.text2}
        date={PhotoContent.date}
        id="photo"
      />
      <BusinessBlock
        direction="left"
        text1={BusinessContent.text1}
        text2={BusinessContent.text2}
        text3={BusinessContent.text3}
        skill1={BusinessContent.skill1}
        skill2={BusinessContent.skill2}
        skill3={BusinessContent.skill3}
        id="business"
          />
      <WhyBlock
        direction="up"
        head={WhyBlockContent.head}
        title={WhyBlockContent.title}
        reason1={WhyBlockContent.reason1}
        detail1={WhyBlockContent.detail1}
        reason2={WhyBlockContent.reason2}
        detail2={WhyBlockContent.detail2}
        reason3={WhyBlockContent.reason3}
        detail3={WhyBlockContent.detail3}
        reason4={WhyBlockContent.reason4}
        detail4={WhyBlockContent.detail4}
        id="why"
      />
      <JoinUsBlock
        direction="up"
        text1={JoinUsBlockContent.text1}
        text2={JoinUsBlockContent.text2}
        id="joinus"
      />
      <ClosingBlock
        direction="up"
        title={ClosingBlockContent.title}
        slogan={ClosingBlockContent.slogan}
        id="closing"
      />
    </Container>
  );
};

export default Home;
